<template>
    <v-layout justify-center v-if="loading" class="portfolio-view">
        <v-responsive max-width="1280px" width="100%" height="100%" class="shop-product-view">
            <div v-if="!$route.query._product" class="headline text-start mt-8">포트폴리오 등록</div>
            <div v-else class="headline text-start mt-8">포트폴리오 상세</div>

            <portfolio-basic v-model="portfolio"></portfolio-basic>

            <v-row justify="center">
                <v-col md="auto" sm="auto">
                    <v-btn color="primary" @click="save">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";

import PortfolioBasic from "@/components/console/portfolio/portfolio-basic.vue";
import PortfolioSpace from "@/components/console/portfolio/portfolio-space.vue";

export default {
    components: {
        PortfolioBasic,
        PortfolioSpace,
    },
    data() {
        return {
            loading : false,

            portfolio: {
                _category: null,
                subject: null,
                content: null,

                thumb: null,
                image: null,
                
                // 시공정보
                construction: {
                    estimatedDate: null, // 견적일자
                    address: null, // 시공지역
                    scope: null, // 시공범위
                    acreage: 0, // 시공면적
                    cost: 0, // 시공비
                    concept: [], // 컨셉
                    color: null, // 컬러
                    request: null, // 요청사항
                    details: null, // 설명
                },

                // 견적서 정보
                estimate: {
                    type: "none", // 견적서 유형 ( data1: 예전양식, data2: 신규양식, file: 파일업로드 )
                    vatEnable: false,
                    discountType: "none", // 할인 유형 (self: 직접입력, rate: 할인률 적용)
                    discountRate: 0,
                    consultingRate: 12,

                    data1: [],
                    data2: {
                        material: {
                            spaces: []
                        },
                        laborCosts: {
                            artificers: []
                        }
                    },
                    file: null,
                },

                // 공간정보
                spaces: []
            },

        }
    },
    async mounted() {
        try {
            await this.init();
            for(var i in this.portfolio._contents) {
                console.log(i);
            }
            this.loading = true;
        }catch(error) {
            console.error(error);
        }
    },
    methods: {
        async init(){
            try{
                var { categories } = await api.console.portfolios.categories.getCategories();
                this.categories = categories;

                if(this.$route.params._portfolio){
                    // 포트폴리오 정보 로드
                    var { portfolio } = await api.console.portfolios.getPortfolio({ _id: this.$route.params._portfolio });
                    this.portfolio = portfolio;

                    // 바이너리 로드
                    if(portfolio.thumb) portfolio.thumb = await api.getResource(portfolio.thumb);
                    if(portfolio.image) portfolio.image = await api.getResource(portfolio.image);
                    if(portfolio.estimate.file) portfolio.estimate.file = await api.getResource(portfolio.estimate.file);

                    for(var space of portfolio.spaces){
                        if(space.beforeImage) space.beforeImage = await api.getResource(space.beforeImage);
                        if(space.afterImage) space.afterImage = await api.getResource(space.afterImage);
                    }
                }
            }
            catch(error){
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async save() {
            try {
                if(this.check()){
                    // 기본정보 저장
                    var { portfolio } = !this.portfolio._id ? await api.console.portfolios.postPortfolio(this.portfolio) : await api.console.portfolios.putPortfolio(this.portfolio);
                    
                    // 썸네일 저장
                    if(this.portfolio.thumb){
                        await api.console.portfolios.postThumb(portfolio._id, this.portfolio.thumb);
                    }
    
                    // 이미지 저장
                    if(this.portfolio.image){
                        await api.console.portfolios.postImage(portfolio._id, this.portfolio.image);
                    }
    
                    // 견적서 파일 저장
                    if(this.portfolio.estimate.file){
                        await api.console.portfolios.postEstimateFile(portfolio._id, this.portfolio.estimate.file);
                    }
                    
                    // 공간 before & after 이미지 저장
                    for(var space of this.portfolio.spaces){
                        var index = this.portfolio.spaces.findIndex(item => item == space);
                        if(space.beforeImage){
                            await api.console.portfolios.postBeforeImage(portfolio._id, index, space.beforeImage);
                        }
                        if(space.afterImage){
                            await api.console.portfolios.postAfterImage(portfolio._id, index, space.afterImage);
                        }
                    }
    
                    alert("완료되었습니다.");
                    this.$router.push('/console/portfolio');
                }
            }catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        check(){
            if(!this.portfolio.construction.supplyPrice) throw new Error("공급가격을 입력해주세요");
            if(!this.portfolio.estimate.type || this.portfolio.estimate.type == "none") throw new Error("견적서를 입력해주세요");
            return true;
        }
    }
}
</script>

<style>
.portfolio-view .theme--light.v-tabs-items { background-color: transparent !important; }
</style>